import { Materializer, Update } from '@wix/materializer'
import { EMPTY_SCHEMA } from './EMPTY_SCHEMA'

export const updateTwoLevelRecords = (materializer: Materializer) => (
	update: Update<void>,
	basePath: [string, string],
	newValue: Record<string, unknown>
) => {
	const currentValue = materializer.get(basePath)
	const updatedValue = Object.keys(currentValue || {}).reduce(
		(acc, key) => {
			if (!newValue.hasOwnProperty(key)) {
				acc[key] = undefined
			}
			return acc
		},
		{ ...newValue }
	)

	for (const key in updatedValue) {
		update(...basePath, key, updatedValue[key], EMPTY_SCHEMA)
	}
}
